export function formatTimestamp(milliseconds: number) {
  const hours = String(milliseconds / 1000 / 60 / 60);
  const minutes = String((milliseconds / 1000 / 60) % 60);

  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
}

export function formatLocalizedTimestamp(milliseconds: number, i18n) {
  const hours = Math.floor(milliseconds / 1000 / 60 / 60);
  const minutes = String(Math.floor(milliseconds / 1000 / 60) % 60);

  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${minutes.padStart(
      2,
      '0'
    )} ${i18n('hours_other')}`;
  }

  return `${minutes.padStart(2, '0')} ${i18n('minutes_other')}`;
}
